import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface CashierState {
    userCurrency: string | undefined;
    // AC-798: currency of the game session mounted right now (null = no game
    // open). While set, a display-currency change must go through a restart
    // confirm on the game page — the session currency is fixed at launch, so a
    // silent switch would leave the header and the game in two currencies.
    activeGameCurrency: string | null;
    // Display currency requested while a game was open, waiting for the player
    // to confirm the game restart. The header select keeps the old value until
    // the game page resolves it.
    pendingCurrencySwitch: string | null;
}

export const cashierInitialState = {
    userCurrency: undefined,
    activeGameCurrency: null,
    pendingCurrencySwitch: null,
} satisfies CashierState as CashierState

const cashierSlice = createSlice({
    name: 'cashier',
    initialState: cashierInitialState,
    reducers: {
        // AC-817: the `user-currency` cookie is written by
        // cookieSyncMiddleware — the reducer only owns state.
        setUserCurrency(state, val: PayloadAction<string>) {
            state.userCurrency = val.payload;
        },
        setActiveGameCurrency(state, val: PayloadAction<string | null>) {
            state.activeGameCurrency = val.payload;
            // A pending switch is meaningless without a game to restart.
            if (val.payload === null) state.pendingCurrencySwitch = null;
        },
        requestCurrencySwitch(state, val: PayloadAction<string>) {
            state.pendingCurrencySwitch = val.payload;
        },
        clearPendingCurrencySwitch(state) {
            state.pendingCurrencySwitch = null;
        },
    },
})

export const {
    setUserCurrency,
    setActiveGameCurrency,
    requestCurrencySwitch,
    clearPendingCurrencySwitch,
} = cashierSlice.actions
export const cashierReducer = cashierSlice.reducer;
